import React from 'react';
import cn from 'classnames';

import styles from './OptionSelector.module.scss';

import { useMonthsYearsFormatter } from '@hooks/useMonthsYearsFormatter';
import { usePhrases } from '@hooks/context/usePhrases';
import { convertMonthsToTermsSlug } from '@modules/PDP/components/NewOfferCard/helpers/convertMonthsToTermsSlug';
import { PlanContractType } from 'types/plan.types';

interface OptionSelectorProps<T> {
  options: T[];
  handleChange: (arg: T) => void;
  selectedOption: T | null;
  contractType?: PlanContractType;
}
export const OptionSelector = <
  T extends {
    months: number;
  },
>({
  options,
  handleChange,
  selectedOption,
  contractType = PlanContractType.Finance,
}: OptionSelectorProps<T>) => {
  const termsPhrases = usePhrases({ name: 'terms' });
  const { monthsYearsFormatter } = useMonthsYearsFormatter();

  return (
    <div className={styles.optionContainer}>
      {options.map(option => (
        <div
          onClick={() => handleChange(option)}
          className={cn(styles.option, {
            [styles.selected]: selectedOption?.months === option.months,
          })}
          key={option.months}
          data-test-params-term={option.months}
        >
          {contractType === PlanContractType.Finance
            ? monthsYearsFormatter({ monthsValue: option.months })
            : termsPhrases[convertMonthsToTermsSlug(option.months)] || option.months}
        </div>
      ))}
    </div>
  );
};
